<template>
  <div class="new_form">
    <form action="#" @submit.prevent="createMap">
      <div>
        <label for="map-name">Name</label>
        <input v-model="inputs.name" id="map-name" type="text" >
      </div>

      <div>
        <label>Map type</label>
        <div class="selectable" :class="{'selectable--selected': inputs.type === 'picture'}">
          <label>
            <input v-model="inputs.type" value="picture" type="radio" name="type"> Background picture
          </label>
          <p><small>Use your own picture</small></p>
          <div v-show="inputs.type === 'picture'">
            <label for="map-picture">Select a picture</label>
            <input id="map-picture" type="file" @change="prepareSelectedPicture">
            <div v-if="mapLoaded && !centerSelected" class="alert--info">
              <div>
                Select the point representing the center of your garden, then...
                <button type="submit" class="creative">Save this map</button>
              </div>
            </div>
            <div v-show="inputs.type === 'picture' && filePreview" id="pic-map" class="map new_form__map" />
          </div>
        </div>

        <div class="selectable" :class="{'selectable--selected': inputs.type === 'osm'}">
          <label>
            <input v-model="inputs.type" value="osm" type="radio" name="type"> OpenStreetMaps
          </label>
          <p><small>Use OpenStreetMap background</small></p>
          <div>
            <div v-if="mapLoaded && !centerSelected" class="alert--info">
              Select the point representing the center of your garden, then...
              <button type="submit" class="creative">Save this map</button>
            </div>
          </div>
          <div v-show="inputs.type === 'osm'" id="osm-map" class="map new_form__map" />
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import mapTools from '../../tools/map/form'

export default {
  name: 'MapForm',
  data () {
    return {
      inputs: {
        name: 'My other garden',
        type: '',
        picture: null,
        center: [0, 0],
        imageSize: null,
      },
      filePreview: null,

      // Maps instances
      pictureMap: null,
      osmMap: null,

      // Form filling state
      mapLoaded: false,
      centerSelected: false,
    }
  },
  methods: {
    createMap () {
      const payload = {
        name: this.inputs.name,
        picture: this.inputs.type === 'picture' ? this.filePreview : null,
        center: this.inputs.center,
        imageSize: this.inputs.imageSize,
      }
      this.$store.dispatch('addMap', payload)
        .then((map) => {
          this.$router.push({ name: 'map', params: { mapId: map.id } })
        })
    },
    destroyMaps () {
      if (this.pictureMap) this.pictureMap.setTarget(null)
      if (this.osmMap) this.osmMap.setTarget(null)
      this.pictureMap = null
      this.osmMap = null
      this.mapLoaded = false
    },
    prepareSelectedPicture (event) {
      const files = event.target.files || event.dataTransfer.files
      const file = files[0]
      const extension = file.name.split('.').pop().toLowerCase()
      if (!['png', 'jpg', 'jpeg', 'svg'].includes(extension)) {
        throw new Error(`${extension} is not a supported file format`)
      }
      this.inputs.picture = file
      const reader = new FileReader()
      // Destroy maps
      this.destroyMaps()

      reader.addEventListener('load', (event) => {
        this.filePreview = event.target.result
        this.createMapFromPicture()
      })
      reader.readAsDataURL(file)
    },
    createMapFromPicture () {
      if (!this.filePreview) return
      // Create new image
      const image = new Image()
      // Update input data and load map when loaded
      image.addEventListener('load', () => {
        // Update input with new data
        this.inputs.imageSize = [image.width, image.height]

        // Create map
        this.pictureMap = mapTools.createMapFromPicture('pic-map', this.filePreview, [0, 0, ...this.inputs.imageSize], this.setCenter)
        this.mapLoaded = true
      })

      // Set image source and load it
      image.src = this.filePreview
    },
    setCenter (center) {
      this.inputs.center = center
    },
  },
  watch: {
    'inputs.type' (newType) {
      this.destroyMaps()
      if (newType === 'osm') {
        this.$nextTick(() => {
          this.osmMap = mapTools.createOSMMap('osm-map', this.setCenter)
          this.mapLoaded = true
        })
      } else {
        this.createMapFromPicture()
      }
    },
  },
}
</script>
